// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PHomeOutlinedSvg from "@fishx/icons-svg/es/asn/PHomeOutlined";
import FishxIcon from '../components/FishxIcon';

var PHomeOutlined = function PHomeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PHomeOutlinedSvg
  }));
};

PHomeOutlined.displayName = 'PHomeOutlined';
export default React.forwardRef(PHomeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PHomeOutlined.js
// module id = 3447
// module chunks = 0